import { useState, useEffect, useCallback } from 'react';
import _ from 'lodash'; // or implement your own debounce
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { toast } from 'react-toastify';
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
// Ensure JS for interactivity
//import PageHeader from '../../../layouts/PageHeader';
// import {
//   confirmDialog,
//   showError,
//   showSuccess,
//   showWarning,
// } from '../../../utils/alertService';
const AddLead = () => {
  const showValue = (val) =>
    val && val.toString().trim() !== '' ? val : 'N/A';

  // State for the form inputs
  const [leadMasterData, setLeadMasterData] = useState({
    id: 0,
    vendor_id: 0,
    branch_id: 0,
    lead_id: 0,
    class_name: '',
    class_id: 0,
    lead_status_id: 1,
    uniq_id: '',
    lead_date: new Date().toISOString().split('T')[0],
    lead_date_import: new Date().toISOString().split('T')[0],
    lead_status: 'New Enquiry',
    lead_type: '',
    lead_type_detail: '',
    lead_rating: '',
    lead_source: '',
    lead_remark: '',
    sr_no_of_import_file: 0,
    company_name: '',
    no_of_employee: '',
    turnover_detail: 0,
    designation_detail: '',
    cust_name: '',
    cust_mobile: '',
    cust_email: '',
    cust_website: '',
    address_line1: '',
    location_detail: '',
    area_detail: '',
    city_name: '',
    state_name: '',
    country_name: '',
    pin_code: '',

    cust_quali: '',
    d_o_b: '',
    cust_wp_mobile: '',
    cust_f_name: '',
    cust_m_name: '',
    cust_sp_name: '',
    cust_f_mob: '',
    cust_m_mob: '',
    cust_sp_mob: '',
    cust_f_prof: '',
    cust_m_prof: '',
    cust_sp_prof: '',

    rec_updated_yn: '',
    lead_belong_to: '',
    lead_belong_to_id: 0,
    lead_import_by_user: '',
    lead_import_by_user_id: 0,
    follow_up: false,
    title: '',
    product: '',
    cust_id: 0,
    status: 'In Progess',
    follow_date: new Date().toISOString().split('T')[0],
    followup_time: null,
    Followup_time: '2025-01-31T16:16:00',
  });
  const [cust_creation_masterData, setcust_creation_masterData] = useState({
    id: 0,
    lead_id: 0,
    uniq_id: '',
    lead_date: new Date().toISOString().split('T')[0],
    lead_date_import: new Date().toISOString().split('T')[0],
    lead_status: '',
    lead_type: '',
    lead_type_detail: '',
    lead_rating: '',
    lead_source: '',
    lead_remark: '',
    sr_no_of_import_file: 0,
    cust_name: '',
    company_name: '',
    no_of_employee: '',
    turnover_detail: 0,
    designation_detail: '',
    cust_mobile: '',
    cust_email: '',
    cust_website: '',
    address_line1: '',
    location_detail: '',
    area_detail: '',
    city_name: '',
    state_name: '',
    country_name: '',
    pin_code: '',
    rec_updated_yn: '',
    lead_belong_to: '',
    lead_belong_to_id: 0,
    lead_import_by_user: '',
    lead_import_by_user_id: 0,
    follow_up: false,
    state_Id: 0,
    city_Id: 0,
    title: '',
    product: '',
    follow_date: new Date().toISOString().split('T')[0],
  });
  const [MPTMasterData, setMPTMasterData] = useState({
    multi_purpose_flag: '',
    multi_purpose_code: '',
    multi_purpose_type: '',
    multi_purpose_remark: '',
  });

  const [qualificationList, setQualificationList] = useState([]);

  const [profList, setProfList] = useState([]);

  const { user } = useSelector((state) => state.authState);
  const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
    useVendorBranch(user);
  const [states, setStates] = useState([]); // State List
  const [cities, setCities] = useState([]); // City List
  const [country, setCountry] = useState([]); // City List
  const [isCustomerPopupOpen, setIsCustomerPopupOpen] = useState(false);
  const [custName, setCustName] = useState('');
  const [modal, setmodal] = useState(false);
  const [dynamicmultipurpose, setdynamicmultipurpose] = useState('');
  const [dynamiclable, setdynamiclable] = useState('');
  const [product, setproduct] = useState('');
  const [errorMessage, setErrorMessage] = useState({});
  const [LeadSourceData, setLeadSourceData] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [classList, setClassList] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [Multi_Purpose_Type_Master_data, setMulti_Purpose_Type_Master_data] =
    useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  //  const { user } = useSelector((state) => state.authState);
  const { rowdat, leadCustomer } = location.state || {};

  useEffect(() => {
    if (leadCustomer) {
      // const selectedState = states.find(
      //   (state) => state.state_Name === leadCustomer.state_name
      // );

      // setcust_creation_masterData((prev) => ({
      //   ...prev,
      //   state_Id: selectedState?.state_Id || '', // fallback if not found
      // }));

      setcust_creation_masterData(leadCustomer);
      setCustName(leadCustomer.cust_name);
    }
  }, [leadCustomer]);

  useEffect(() => {
    if (rowdat) {
      // debugger;

      const followDate = new Date(rowdat.lead_date);
      const formattedDate = `${followDate.getFullYear()}-${String(
        followDate.getMonth() + 1,
      ).padStart(2, '0')}-${String(followDate.getDate()).padStart(2, '0')}`;

      const updatedRow = {
        ...rowdat,
        lead_date: formattedDate,
      };

      setLeadMasterData(updatedRow);
    }
  }, [rowdat]);

  const handleCustomerClick = (data) => {
    // debugger;
    leadMasterData.cust_id = data.id;
    leadMasterData.cust_name = data.cust_name;
    leadMasterData.cust_email = data.cust_email;
    leadMasterData.cust_mobile = data.cust_mobile;
    leadMasterData.company_name = data.company_name;
    setCustName(data.cust_name);
    setSuggestions([]);
  };
  const handlemultipurposeClick = (data) => {
    // debugger;
    leadMasterData.product = data.multi_purpose_type;
    setLeadMasterData((prevData) => ({
      ...prevData,
      ['product']: data.multi_purpose_type,
    }));
    setproduct(data.multi_purpose_type);
    setClassList([]);
  };
  const toggle = () => setmodal(!modal);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   if (value.length > 3) {
  //     SearchCustomerByName(value);
  //   }
  //   setCustName(value);
  // };
  const handleChange = (e) => {
    const value = e.target.value;
    setCustName(value);
    SearchCustomerByName(value); // call on every change
  };
  const handleChangeMulti = (e) => {
    const { name, value } = e.target;

    setLeadMasterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setproduct(value);

    if (value.length === 0) {
      // If user clears input, show default again
      SearchProductFromMultiPurpose('');
    } else if (value.length > 2) {
      SearchProductFromMultiPurpose(value); // Search with keyword
    }
  };

  // // const handleChangeMulti = (e) => {
  // //   // debugger;
  // //   const { name, value } = e.target;
  // //   setLeadMasterData((prevData) => ({
  // //     ...prevData,
  // //     [name]: value,
  // //   }));

  //   // Call search API on every change, regardless of length
  //   SearchProductFromMultiPurpose(value);

  //   setproduct(value);
  // };

  const onChangeHandle = (e) => {
    // debugger;
    const { name, value } = e.target;

    setLeadMasterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // if (name === 'product') {
    //   SearchProductFromMultiPurpose(value);
    // }
    setErrorMessage((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
  };
  const onHandleMultipleValue = (param) => {
    // debugger;
    setmodal(!modal);
    setMPTMasterData((prevData) => ({
      ...prevData,
      multi_purpose_flag: param,
    }));
  };

  const onChangeHandle1 = (e) => {
    const { name, value } = e.target;
    // debugger;
    setMPTMasterData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const MPTMaster_Add_Edit_Screen = async () => {
    try {
      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      const data = JSON.stringify(MPTMasterData);

      let response;

      if (MPTMasterData.id === '0' || MPTMasterData.id === 0) {
        response = await apiService.put(
          `api/Multi_Purpose_Type_Master/UpdateMulti_Purpose_Type_Master?id=${MPTMasterData.id}`,
          data,
          config,
        );
      } else {
        response = await apiService.post(
          'api/Multi_Purpose_Type_Master/AddMulti_Purpose_Type_Master',
          data,
          config,
        );
      }
      // debugger;
      if (response.status === true) {
        toast.success(response.message);
        //showSuccess(response.message, '');
        //resetMPTMasterData();
        setmodal(!modal);
        //Get_All_MPT_Master();
        getMulti_Purpose_Type_MasterData();
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong"');
    }
  };

  // Validate inputs before submission
  const validateInputs = () => {
    const errors = {};

    // Validate Semester (must be a number > 0)
    if (isSuperAdmin) {
      if (!leadMasterData.vendor_id || Number(leadMasterData.vendor_id) <= 0) {
        toast.error('Please select a Vendor');
        return false;
      }
    }

    // Admin OR multi-branch user → must select branch
    if (isSuperAdmin || isAdmin || hasMultiBranch) {
      // Validate Semester (must be a number > 0)
      if (!leadMasterData.branch_id || Number(leadMasterData.branch_id) <= 0) {
        toast.error('Please select a Branch');
        return false;
      }
    }

    if (!leadMasterData.cust_name) {
      errors.cust_name = 'Customer Name is required.';
      toast.error(errors.cust_name);
    }

    // if (!leadMasterData.cust_mobile) {
    //   errors.cust_mobile = 'Customer Mobile is required.';
    //   toast.error(errors.cust_mobile);
    // } else if (!/^\d{10}$/.test(leadMasterData.cust_mobile)) {
    //   errors.cust_mobile = 'Customer Mobile must be a valid 10-digit number.';
    //   toast.error(errors.cust_mobile);
    // }

    if (!leadMasterData.lead_source) {
      errors.lead_source = 'Lead Source is required.';
      toast.error(errors.lead_source);
    }
    if (!leadMasterData.lead_date) {
      errors.lead_date = 'Lead Date is required.';
      toast.error(errors.lead_date);
    }
    // if (!leadMasterData.class_id || isNaN(leadMasterData.class_id) || Number(leadMasterData.class_id) <= 0)
    //   errors.class_id = 'Course selection is required.';
    return errors;
  };

  // const onChangeCustomerHandle = (e) => {
  //   const { name, value } = e.target;
  //   setcust_creation_masterData((prevState) => ({
  //     ...prevState,
  //     [name]: value, // Update the specific field based on the input's name
  //   }));
  // };
  const onChangeCustomerHandle = (e) => {
    // debugger;
    const { name, value } = e.target;
    // debugger;
    if (name === 'country_Id') {
      const selectedState = country.find((state) => state.id === value);

      setcust_creation_masterData((prevState) => ({
        ...prevState,
        country_name: selectedState.country_name || '',
        state_name: '',
        city_name: '',
        city_Id: 0,
      }));

      if (value) {
        getStates(value); // 🔁 Call to fetch cities
      }
    }
    if (name === 'state_Id') {
      const selectedState = states.find((state) => state.state_Id === value);

      setcust_creation_masterData((prevState) => ({
        ...prevState,
        state_Id: selectedState.state_Id || 0,
        state_name: selectedState.state_Name || '',
        state_of_residence: selectedState.state_Short_Name || '',
        city_name: '',
        city_Id: 0,
      }));

      if (selectedState) {
        getCitiesByState(value); // 🔁 Call to fetch cities
      }
    } else if (name === 'city_Id') {
      const selectedCity = cities.find((city) => city.id === value);

      setcust_creation_masterData((prevState) => ({
        ...prevState,
        city_Id: selectedCity.id || 0,
        city_name: selectedCity.city_name || '',
      }));
    } else {
      setcust_creation_masterData((prevState) => ({
        ...prevState,
        [name]: value || '',
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateInputs();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      // ❌ Stop submission if errors exist
      return;
    }
    try {
      // debugger;

      let config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };
      //leadMasterData.cust_name = custName;
      const data = JSON.stringify(leadMasterData);
      let response;
      // debugger;
      if (leadMasterData.id && leadMasterData.id !== 0) {
        // 🔄 Update
        response = await apiService.put(
          `api/Lead_Master_Import/UpdateLead_Master_Import?id=${leadMasterData.id}`,
          data,
          config,
        );
      } else {
        // ➕ Insert
        response = await apiService.post(
          'api/Lead_Master_Import/AddLead_Master_Import',
          data,
          config,
        );
      }
      if (response.status) {
        toast.success(response.message || 'Lead saved successfully!');
        //showSuccess(response.message, '');
        navigate('/all-leads');
      } else {
        alert(response.message || 'Failed to save the lead.');
      }

      // Reset form after successful submission
      // setLeadMasterData({
      //   id: 0,
      //   lead_id: 0,
      //   uniq_id: '',
      //   lead_date: new Date().toISOString().split('T')[0],
      //   lead_date_import: new Date().toISOString().split('T')[0],
      //   lead_status: '',
      //   lead_type: '',
      //   lead_type_detail: '',
      //   lead_rating: '',
      //   lead_source: '',
      //   lead_remark: '',
      //   sr_no_of_import_file: 0,
      //   cust_name: '',
      //   company_name: '',
      //   no_of_employee: '',
      //   turnover_detail: 0,
      //   designation_detail: '',
      //   cust_mobile: '',
      //   cust_email: '',
      //   cust_website: '',
      //   address_line1: '',
      //   location_detail: '',
      //   area_detail: '',
      //   city_name: '',
      //   state_name: '',
      //   country_name: '',
      //   pin_code: '',
      //   rec_updated_yn: '',
      //   lead_belong_to: '',
      //   lead_belong_to_id: 0,
      //   lead_import_by_user: '',
      //   lead_import_by_user_id: 0,
      //   follow_up: false,
      //   title: '',
      // });
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong while saving the lead.');
    }
  };

  // const GetUserMaster = async () => {
  //   try {
  //     let config = {
  //       headers: {
  //         'Content-Type': 'application/json', // Important for file upload//s
  //         accept: 'application/json',
  //       },
  //     };
  //     const response = await apiService.get(
  //       `api/admin/User_Detail/GetUsers`,
  //       config
  //     );
  //     if (response.response && response.response.data.errors) {
  //       alert(response.response?.data?.errors);
  //     }
  //     setuser(response);
  //   } catch (error) {
  //     console.log(error);
  //     alert('SomeThing went wrong!!');
  //   }
  // };

  const SearchCustomerByName = async (customerName = '') => {
    try {
      setIsLoading(true);

      const trimmedInput = customerName.trim();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      // ✅ Always call API — backend will handle both default & search
      const response = await apiService.get(
        `api/Lead_Master_Import/SearchCustomerByName?customerName=${trimmedInput}`,
        config,
      );

      // ✅ Adjust according to your response shape
      setSuggestions(response?.data1 || []);
    } catch (error) {
      console.error('Error fetching customer suggestions:', error);
      setSuggestions([]);
    } finally {
      setIsLoading(false);
    }
  };

  const SearchProductFromMultiPurpose = async (searchTerm) => {
    try {
      if (isSuperAdmin) {
        if (
          !leadMasterData.vendor_id ||
          Number(leadMasterData.vendor_id) <= 0
        ) {
          toast.error('Please select a Vendor');
          return false;
        }
      }

      // Admin OR multi-branch user → must select branch
      if (isSuperAdmin || isAdmin || hasMultiBranch) {
        // Validate Semester (must be a number > 0)
        if (
          !leadMasterData.branch_id ||
          Number(leadMasterData.branch_id) <= 0
        ) {
          toast.error('Please select a Branch');
          return false;
        }
      }

      const trimmedInput = searchTerm.trim();

      // Optional optimization: don't hit API for very short text
      // if (trimmedInput.length > 0 && trimmedInput.length < 2) {
      //   setClassList([]);
      //   return;
      // }

      setIsLoading1(true);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      // ✅ API call with both parameters
      const response = await apiService.get(
        `api/ClassMaster/GetClassList?vendorId=${leadMasterData.vendor_id}&branchId=${leadMasterData.branch_id}&searchItem=${trimmedInput}`,
        config,
      );

      setClassList(response?.classList || []); // adjust as per your API response shape
    } catch (error) {
      console.error('Error fetching product suggestions:', error);
      setClassList([]);
    } finally {
      setIsLoading1(false);
    }
  };

  const breadcrumbData = [
    { label: 'Masters', path: '/masters' },
    { label: 'Lead Master', path: '/masters/Lead Master' },
  ];

  const actionItems = []; // Add action buttons here if needed

  // ✅ Countries Fetch
  const GetAllCountry = async () => {
    try {
      const response = await apiService.get(
        'api/Multi_Purpose_Type_Master/GetAllCountry',
      );
      if (response.status === true) {
        setCountry(response.data4); // Countries list set
        console.log(response.data4);

        if (leadCustomer && response?.data4?.length > 0) {
          const selectedCountry = response.data4.find(
            (c) => c.country_name === leadCustomer.country_name,
          );
          if (selectedCountry) {
            getStates(selectedCountry.id);
          }

          setcust_creation_masterData((prev) => ({
            ...prev,
            country_Id: selectedCountry?.id || 0,
            country_name: selectedCountry?.country_name || '',
          }));
        }
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    }
  };

  // ✅ States Fetch
  const getStates = async (countryId) => {
    try {
      const response = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetStates?countryId=${countryId}`,
      );
      if (response.status === true) {
        setStates(response.data1); // States list set
        console.log(response.data1);

        if (leadCustomer && response?.data1?.length > 0) {
          const selectedState = response.data1.find(
            (s) => s.state_Name === leadCustomer.state_name,
          );
          if (selectedState) {
            getCitiesByState(selectedState.state_Id);
          }

          setcust_creation_masterData((prev) => ({
            ...prev,
            state_Id: selectedState?.state_Id || 0,
            state_name: selectedState?.state_Name || '',
          }));
        }
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    }
  };

  // ✅ Cities Fetch
  const getCitiesByState = async (stateId) => {
    try {
      const response = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetCities?stateId=${stateId}`,
      );
      // debugger;
      if (response.status === true) {
        setCities(response.data2); // Cities list set
        // debugger;
        if (leadCustomer && response?.data2?.length > 0) {
          const selectedCity = response.data2.find(
            (c) => c.city_name === leadCustomer.city_name,
          );

          setcust_creation_masterData((prev) => ({
            ...prev,
            city_Id: selectedCity?.id || 0,
            city_name: selectedCity?.city_name || '',
          }));
        }
      }
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    }
  };

  // Handle suggestion click
  const handleSuggestionClick = (name) => {
    setCustName(name); // Set the clicked suggestion as the input value
    setSuggestions([]); // Clear suggestions
    setClassList([]);
  };
  const getMulti_Purpose_Type_MasterData = async () => {
    try {
      const response = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=lead_source&orderBy=id`,
        {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        },
      );

      // ✅ Validation error handling
      if (response?.data?.errors) {
        alert(Object.values(response.data.errors).join(', '));
        return;
      }

      // ✅ Success case
      if (response.status === true) {
        const allData = response.data;

        setLeadSourceData(allData);
      } else {
        alert(response.message || 'Failed to fetch data');
      }

      //qualification list
      const response2 = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=Qualification&orderBy=id`,
        {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        },
      );

      // ✅ Validation error handling
      if (response2?.data?.errors) {
        alert(Object.values(response2.data.errors).join(', '));
        return;
      }

      // ✅ Success case
      if (response2.status === true) {
        const allData = response2.data;

        setQualificationList(allData);
      } else {
        alert(response2.message || 'Failed to fetch data');
      }

      //Profession list
      const response3 = await apiService.get(
        `api/Multi_Purpose_Type_Master/GetMulti_Purpose_Type_Master?filter=Profession&orderBy=id`,
        {
          headers: {
            'Content-Type': 'application/json',
            accept: 'application/json',
          },
        },
      );

      // ✅ Validation error handling
      if (response3?.data?.errors) {
        alert(Object.values(response3.data.errors).join(', '));
        return;
      }

      // ✅ Success case
      if (response3.status === true) {
        const allData = response3.data;

        setProfList(allData);
      } else {
        alert(response3.message || 'Failed to fetch data');
      }
    } catch (error) {
      console.error('API Error:', error);
      alert('Something went wrong while fetching multi-purpose data');
    }
  };

  //customer add
  const customerhandleSubmit = async (e) => {
    e.preventDefault();
    // debugger;

    try {
      const config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      };

      // Inside your submit handler (before stringifying):
      const rawMobile = String(cust_creation_masterData.cust_mobile).trim();
      const isValidMobile = /^[6-9]\d{9}$/.test(rawMobile);

      if (!isValidMobile) {
        toast.error('Invalid mobile number');
        return;
      }

      const formattedMobile = rawMobile.startsWith('+91')
        ? rawMobile
        : '+91' + rawMobile;

      const updatedData = {
        ...cust_creation_masterData,
        cust_mobile: rawMobile,
        // cust_mobile: formattedMobile,
      };

      const data = JSON.stringify(updatedData);

      let response;

      if (updatedData.id !== 0) {
        response = await apiService.post(
          `api/Lead_Master_Import/UpdateCustomerMaster`,
          data,
          config,
        );
      } else {
        response = await apiService.post(
          'api/Lead_Master_Import/InsertCustomerMaster',
          data,
          config,
        );
      }
      // debugger;
      if (response.status) {
        leadMasterData.cust_id = response.data1;
        toast.success(response.message || 'Customer saved successfully!');
        //showSuccess(response.message, '');
        setIsCustomerPopupOpen(false);
      } else {
        alert(response.message || 'Failed to save the lead.');
      }

      // Reset the form
      setcust_creation_masterData({
        id: 0,
        lead_id: 0,
        uniq_id: '',
        lead_date: new Date().toISOString().split('T')[0],
        lead_date_import: new Date().toISOString().split('T')[0],
        lead_status: '',
        lead_type: '',
        lead_type_detail: '',
        lead_rating: '',
        lead_source: '',
        lead_remark: '',
        sr_no_of_import_file: 0,
        cust_name: '',
        company_name: '',
        no_of_employee: '',
        turnover_detail: 0,
        designation_detail: '',
        cust_mobile: '',
        cust_email: '',
        cust_website: '',
        address_line1: '',
        location_detail: '',
        area_detail: '',
        city_name: '',
        state_name: '',
        country_name: '',
        pin_code: '',
        rec_updated_yn: '',
        lead_belong_to: '',
        lead_belong_to_id: 0,
        lead_import_by_user: '',
        lead_import_by_user_id: 0,
        follow_up: false,
        title: '',
        followup_time: null,
        Followup_time: '2025-01-31T16:16:00',
      });
    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong while saving the lead.');
    }
  };

  useEffect(() => {
    getMulti_Purpose_Type_MasterData();
    // GetUserMaster();
    GetAllCountry();
  }, []);

  useEffect(() => {
    if (cust_creation_masterData.country_Id) {
      getStates(cust_creation_masterData.country_Id);
    }
  }, [cust_creation_masterData.country_Id]);

  // Jab state change ho, tab cities load karna
  useEffect(() => {
    if (cust_creation_masterData.state_Id) {
      getCitiesByState(cust_creation_masterData.state_Id);
    }
  }, [cust_creation_masterData.state_Id]);

  const debouncedSearch = useCallback(
    _.debounce(SearchCustomerByName, 500),
    [],
  );

  useEffect(() => {
    const canLoad = conditionalDataLoad({
      hasMultiBranch,
      hasSingleBranch,
      isSuperAdmin,
      isAdmin,
      vendorId: leadMasterData.vendor_id,
      branchId: leadMasterData.branch_id,
    });
    if (canLoad) {
      // ✅ Load default 10 records initially OR search dynamically
      SearchCustomerByName(custName || '');

      // Also load default 10 products on page load
      SearchProductFromMultiPurpose('');
    }
  }, [leadMasterData.vendor_id, leadMasterData.branch_id, custName]);

  const steps = [
    { id: 0, label: 'Lead Info' },
    { id: 1, label: 'Personal' },
    { id: 2, label: 'Contact' },
    { id: 3, label: 'Family' },
    { id: 4, label: 'Address' },
    { id: 5, label: 'Review' },
  ];

  const [activeStep, setActiveStep] = useState(0);

  const nextStep = () => {
    if (activeStep < steps.length - 1) setActiveStep(activeStep + 1);
  };

  const prevStep = () => {
    if (activeStep > 0) setActiveStep(activeStep - 1);
  };

  return (
    <>
      {/* <PageHeader
        title='Add Lead Master Form'
        breadcrumbs={breadcrumbData}
        actions={actionItems}
      /> */}
      <div className='bg-white pd-5 card-box mb-5 toolbar-row sticky-top border text-right mb-3'>
        <Link className='btn btn-secondary btn-sm mr-2' to='/all-leads'>
          <i className='bi bi-arrow-left mr-1'></i> Back
        </Link>

        <button className='btn btn-success btn-sm mr-2' onClick={handleSubmit}>
          <i className='bi bi-check-circle mr-1'></i> Save
        </button>
      </div>
      <VendorBranchSelector
        user={user}
        selectionData={leadMasterData}
        setSelectionData={setLeadMasterData}
        errorMessage={errorMessage}
        accessButton={true}
      />

      <div className='card shadow-sm border-0 p-4 mb-4'>
        <div class='wizard-content'>
          <div class='tab-wizard wizard-circle wizard clearfix'>
            <div class='steps clearfix'>
              <ul role='tablist' className='steps mb-3'>
                {steps.map((step, index) => {
                  const isCurrent = activeStep === index;
                  const isDone = index < activeStep;
                  const isDisabled = index > activeStep;

                  return (
                    <li
                      key={step.id}
                      role='tab'
                      className={`
          ${index === 0 ? 'first' : ''}
          ${index === steps.length - 1 ? 'last' : ''}
          ${isCurrent ? 'current' : ''}
          ${isDone ? 'done' : ''}
          ${isDisabled ? 'disabled' : ''}
        `}
                      aria-disabled={isDisabled}
                      aria-selected={isCurrent}
                    >
                      <a
                        href='#'
                        id={`steps-${step.id}-t-${index}`}
                        aria-controls={`steps-${step.id}-p-${index}`}
                        onClick={(e) => {
                          e.preventDefault();
                          if (!isDisabled) setActiveStep(index);
                        }}
                      >
                        {isCurrent && (
                          <span className='current-info audible'>
                            current step:
                          </span>
                        )}
                        <span className='step'>{index + 1}</span> {step.label}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>

            {activeStep === 0 && (
              <>
                <h5 className='fw-bold text-secondary mb-3'>Lead Details</h5>
                <div className='row g-3 mb-3'>
                  {/* Customer Name with autocomplete function */}
                  {/* <div className="col-md-6">
            <label htmlFor="cust_name" className="form-label fw-semibold">
              Applicant Name
            </label>
            <div className="input-group">
              <Autocomplete
                size="small"
                autoHighlight
                id="cust_name"
                options={suggestions || []}
                getOptionLabel={(option) => option.cust_name || ''}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Type customer name..." fullWidth />
                )}
                value={
                  suggestions.find((option) => option.cust_name === custName) || null
                }
                onChange={(event, newValue) => newValue && handleCustomerClick(newValue)}
                inputValue={custName}
                onInputChange={(event, newInputValue) => setCustName(newInputValue)}
                loading={isLoading}
                sx={{ flex: 1 }}
              />
              <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() => setIsCustomerPopupOpen(!modal)}
              >
                <i className="bi bi-plus"></i>
              </button>
            </div>

            {errors.cust_name && (
              <div className="text-danger small mt-1">{errors.cust_name}</div>
            )}
          </div> */}

                  {/* Product */}
                  <div className='col-md-6'>
                    <label
                      htmlFor='class_id'
                      className='form-label fw-semibold'
                    >
                      Interested In Course
                    </label>
                    <div className='input-group'>
                      <Autocomplete
                        size='small'
                        autoHighlight
                        id='class_id'
                        options={classList || []}
                        getOptionLabel={(option) => option.class_Name || ''}
                        loading={isLoading1}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='Select or type product name...'
                            fullWidth
                          />
                        )}
                        onInputChange={(event, newInputValue) => {
                          SearchProductFromMultiPurpose(newInputValue);
                        }}
                        onChange={(event, newValue) =>
                          newValue &&
                          onChangeHandle({
                            target: {
                              name: 'class_id',
                              value: newValue.id,
                            },
                          })
                        }
                        value={
                          classList.find(
                            (option) => option.id === leadMasterData.class_id,
                          ) || null
                        }
                        sx={{ flex: 1 }}
                      />
                      {/* <button
                type="button"
                className="btn btn-primary btn-sm"
                onClick={() =>
                  onHandleMultipleValue(
                    'product',
                    setdynamicmultipurpose('Add Product Source'),
                    setdynamiclable('Product Source Name')
                  )
                }
              >
                <i className="bi bi-plus"></i>
              </button> */}
                    </div>
                    {errors.class_id && (
                      <div className='text-danger small mt-1'>
                        {errors.class_id}
                      </div>
                    )}
                  </div>

                  {/* Lead Source */}
                  <div className='col-md-4'>
                    <label
                      htmlFor='lead_source'
                      className='form-label fw-semibold'
                    >
                      Lead Source
                    </label>
                    <div className='input-group'>
                      <Autocomplete
                        size='small'
                        autoHighlight
                        id='lead_source'
                        options={LeadSourceData || []}
                        getOptionLabel={(option) =>
                          option.multi_purpose_type || ''
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder='Select Lead Source'
                            fullWidth
                          />
                        )}
                        value={
                          LeadSourceData.find(
                            (option) =>
                              option.multi_purpose_type ===
                              leadMasterData.lead_source,
                          ) || null
                        }
                        onChange={(event, newValue) =>
                          newValue &&
                          onChangeHandle({
                            target: {
                              name: 'lead_source',
                              value: newValue.multi_purpose_type,
                            },
                          })
                        }
                        sx={{ flex: 1 }}
                      />
                      <button
                        type='button'
                        className='btn btn-primary btn-sm'
                        onClick={() =>
                          onHandleMultipleValue(
                            'lead_source',
                            setdynamicmultipurpose('Add Lead Source'),
                            setdynamiclable('Lead Source Name'),
                          )
                        }
                      >
                        <i className='bi bi-plus'></i>
                      </button>
                    </div>
                    {errors.lead_source && (
                      <div className='text-danger small'>
                        {errors.lead_source}
                      </div>
                    )}
                  </div>

                  {/* Lead Date */}
                  <div className='col-md-2'>
                    <label
                      htmlFor='lead_date'
                      className='form-label fw-semibold'
                    >
                      Lead Date <span className='text-danger'></span>
                    </label>
                    <input
                      type='date'
                      name='lead_date'
                      id='lead_date'
                      className='form-control'
                      value={leadMasterData.lead_date}
                      onChange={onChangeHandle}
                    />
                  </div>

                  {errors.lead_date && (
                    <div className='text-danger small mt-1'>
                      {errors.lead_date}
                    </div>
                  )}

                  {/* ✅ Remark */}
                  <div className='col-md-12 mb-3'>
                    <label
                      htmlFor='lead_remark'
                      className='form-label fw-semibold'
                    >
                      Remark
                    </label>
                    <textarea
                      name='lead_remark'
                      id='lead_remark'
                      className='form-control'
                      rows='1'
                      value={leadMasterData.lead_remark}
                      onChange={onChangeHandle}
                      placeholder='Enter any additional details...'
                    ></textarea>
                  </div>
                </div>
              </>
            )}
            {activeStep === 1 && (
              <>
                <h5 className='fw-bold text-primary mb-3'>Personal Details</h5>

                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <label className='form-label'>Full Name</label>
                    <input
                      type='text'
                      className='form-control'
                      name='cust_name'
                      value={leadMasterData.cust_name}
                      onChange={onChangeHandle}
                    />
                  </div>

                  <div className='col-md-6 mb-3'>
                    <label className='form-label'>Date of Birth</label>
                    <input
                      type='date'
                      className='form-control'
                      name='d_o_b'
                      value={leadMasterData.d_o_b}
                      onChange={onChangeHandle}
                    />
                  </div>

                  <div className='col-md-12'>
                    <label className='form-label'>Academic Qualification</label>
                    {/* Qualification dropdown */}
                    <select
                      type='text'
                      className='form-control'
                      name='cust_quali'
                      value={leadMasterData.cust_quali}
                      onChange={onChangeHandle}
                    >
                      <option value='0'>-Select-</option>
                      {qualificationList.map((option) => (
                        <option
                          key={option.multi_purpose_type}
                          value={option.multi_purpose_type}
                        >
                          {option.multi_purpose_type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </>
            )}
            {activeStep === 2 && (
              <>
                <h5 className='fw-bold text-success mb-3'>Contact Details</h5>

                <div className='row'>
                  <div className='col-md-6 mb-3'>
                    <label className='form-label'>Mobile</label>
                    {/* Mobile + Country Code */}
                    <div className='mb-3 col-md-6'>
                      <label className='form-label'>Mobile</label>
                      <div className='d-flex'>
                        <select
                          className='custom-select'
                          name='country_code'
                          style={{ maxWidth: '100px', marginRight: '10px' }}
                          value={cust_creation_masterData.country_code}
                          onChange={onChangeCustomerHandle}
                        >
                          <option value='+91'>+91</option>
                        </select>
                        <input
                          type='text'
                          className='form-control'
                          name='cust_mobile'
                          value={cust_creation_masterData.cust_mobile}
                          onChange={onChangeCustomerHandle}
                          placeholder='Enter mobile number'
                        />
                      </div>
                    </div>
                  </div>

                  <div className='col-md-6 mb-3'>
                    <label className='form-label'>Email</label>
                    <input
                      type='email'
                      className='form-control'
                      name='cust_email'
                      value={leadMasterData.cust_email}
                      onChange={onChangeHandle}
                    />
                  </div>

                  <div className='col-md-6 mb-3'>
                    <label className='form-label'>WhatsApp</label>
                    <input
                      type='text'
                      className='form-control'
                      name='cust_wp_mobile'
                      value={leadMasterData.cust_wp_mobile}
                      onChange={onChangeHandle}
                    />
                  </div>

                  <div className='col-md-6 mb-3'>
                    <label className='form-label'>Reference</label>
                    <input
                      type='text'
                      className='form-control'
                      name='company_name'
                      value={leadMasterData.company_name}
                      onChange={onChangeHandle}
                    />
                  </div>
                </div>
              </>
            )}
            {activeStep === 3 && (
              <>
                <h5 className='fw-bold text-dark mb-3'>Family Details</h5>
                {/* Father / Mother / Spouse blocks (unchanged, just moved here) */}
                <div className='row'>
                  {/* Father */}
                  <div className='col-md-4 border-right'>
                    <h6 className='fw-semibold mb-2 text-primary'>Father</h6>

                    <div className='mb-3'>
                      <label className='form-label'>Name</label>
                      <input
                        type='text'
                        className='form-control'
                        name='cust_f_name'
                        value={leadMasterData.cust_f_name}
                        onChange={onChangeHandle}
                      />
                    </div>

                    <div className='mb-3'>
                      <label className='form-label'>Mobile</label>
                      <input
                        type='text'
                        className='form-control'
                        name='cust_f_mob'
                        value={leadMasterData.cust_f_mob}
                        onChange={onChangeHandle}
                      />
                    </div>

                    <div className='mb-3'>
                      <label className='form-label'>Profession</label>
                      <select
                        type='text'
                        className='form-control'
                        name='cust_f_prof'
                        value={leadMasterData.cust_f_prof}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {profList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* Mother */}
                  <div className='col-md-4 border-right'>
                    <h6 className='fw-semibold mb-2 text-primary'>Mother</h6>

                    <div className='mb-3'>
                      <label className='form-label'>Name</label>
                      <input
                        type='text'
                        className='form-control'
                        name='cust_m_name'
                        value={leadMasterData.cust_m_name}
                        onChange={onChangeHandle}
                      />
                    </div>

                    <div className='mb-3'>
                      <label className='form-label'>Mobile</label>
                      <input
                        type='text'
                        className='form-control'
                        name='cust_m_mob'
                        value={leadMasterData.cust_m_mob}
                        onChange={onChangeHandle}
                      />
                    </div>

                    <div className='mb-3'>
                      <label className='form-label'>Profession</label>
                      <select
                        type='text'
                        className='form-control'
                        name='cust_m_prof'
                        value={leadMasterData.cust_m_prof}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {profList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className='col-md-4'>
                    <h6 className='fw-semibold mb-2 text-primary'>Spouse</h6>
                    <div className='mb-3'>
                      <label className='form-label'>Name</label>
                      <input
                        type='text'
                        className='form-control'
                        name='cust_sp_name'
                        value={leadMasterData.cust_sp_name}
                        onChange={onChangeHandle}
                      />
                    </div>

                    <div className='mb-3'>
                      <label className='form-label'>Mobile</label>
                      <input
                        type='text'
                        className='form-control'
                        name='cust_sp_mob'
                        value={leadMasterData.cust_sp_mob}
                        onChange={onChangeHandle}
                      />
                    </div>

                    <div className='mb-3'>
                      <label className='form-label'>Profession</label>
                      <select
                        className='form-control'
                        name='cust_sp_prof'
                        value={leadMasterData.cust_sp_prof}
                        onChange={onChangeHandle}
                      >
                        <option value='0'>-Select-</option>
                        {profList.map((option) => (
                          <option
                            key={option.multi_purpose_type}
                            value={option.multi_purpose_type}
                          >
                            {option.multi_purpose_type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </>
            )}
            {activeStep === 4 && (
              <>
                <h5 className='fw-bold text-secondary mb-3'>Address</h5>

                <div className='row'>
                  <div className='col-md-10 mb-3'>
                    <label className='form-label'>Address</label>
                    <input
                      type='text'
                      className='form-control'
                      name='address_line1'
                      value={leadMasterData.address_line1}
                      onChange={onChangeHandle}
                    />
                  </div>

                  <div className='col-md-2 mb-3'>
                    <label className='form-label'>Pincode</label>
                    <input
                      type='text'
                      className='form-control'
                      name='pin_code'
                      value={leadMasterData.pin_code}
                      onChange={onChangeHandle}
                    />
                  </div>
                </div>

                {/* Country / State / City (equal width) */}
                {/* <div className='row'>
                  <div className='mb-3 col-md-4'>
                    <label className='form-label'>Country</label>
                    <select
                      className='custom-select'
                      name='country_Id'
                      value={cust_creation_masterData.country_Id}
                      onChange={onChangeHandle}
                    >
                      <option value=''>Select Country</option>
                      {Array.isArray(country) &&
                        country.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.country_name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className='mb-3 col-md-4'>
                    <label className='form-label'>State</label>
                    <select
                      className='custom-select'
                      name='state_Id'
                      value={cust_creation_masterData.state_Id}
                      onChange={onChangeHandle}
                      disabled={!cust_creation_masterData.country_Id}
                    >
                      <option value=''>Select State</option>
                      {Array.isArray(states) &&
                        states.map((s) => (
                          <option key={s.state_Id} value={s.state_Id}>
                            {s.state_Name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className='mb-3 col-md-4'>
                    <label className='form-label'>City</label>
                    <select
                      className='custom-select'
                      name='city_Id'
                      value={cust_creation_masterData.city_Id}
                      onChange={onChangeHandle}
                      disabled={!cust_creation_masterData.state_Id}
                    >
                      <option value=''>Select City</option>
                      {Array.isArray(cities) &&
                        cities.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.city_name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div> */}
              </>
            )}
            {activeStep === 5 && (
              <>
                <h5 className='fw-bold text-success mb-3'>Review & Submit</h5>

                {/* BASIC DETAILS */}
                <div className='card mb-3 shadow-sm'>
                  <div className='card-header fw-bold'>Customer Details</div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-6 mb-2'>
                        <b>Name:</b> {showValue(leadMasterData.cust_name)}
                      </div>
                      <div className='col-md-6 mb-2'>
                        <b>Mobile:</b> {showValue(leadMasterData.cust_mobile)}
                      </div>
                      <div className='col-md-6 mb-2'>
                        <b>Email:</b> {showValue(leadMasterData.cust_email)}
                      </div>
                      <div className='col-md-6 mb-2'>
                        <b>Website:</b> {showValue(leadMasterData.cust_website)}
                      </div>
                      <div className='col-md-6 mb-2'>
                        <b>Date of Birth:</b> {showValue(leadMasterData.d_o_b)}
                      </div>
                      <div className='col-md-6 mb-2'>
                        <b>Qualification:</b>{' '}
                        {showValue(leadMasterData.cust_quali)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* ADDRESS */}
                <div className='card mb-3 shadow-sm'>
                  <div className='card-header fw-bold'>Address Details</div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-12 mb-2'>
                        <b>Address:</b>{' '}
                        {showValue(leadMasterData.address_line1)}
                      </div>
                      <div className='col-md-6 mb-2'>
                        <b>Location:</b>{' '}
                        {showValue(leadMasterData.location_detail)}
                      </div>
                      <div className='col-md-6 mb-2'>
                        <b>Area:</b> {showValue(leadMasterData.area_detail)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>City:</b> {showValue(leadMasterData.city_name)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>State:</b> {showValue(leadMasterData.state_name)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Country:</b> {showValue(leadMasterData.country_name)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Pincode:</b> {showValue(leadMasterData.pin_code)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* FAMILY DETAILS */}
                <div className='card mb-3 shadow-sm'>
                  <div className='card-header fw-bold'>Family Information</div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-4 mb-2'>
                        <b>Father Name:</b>{' '}
                        {showValue(leadMasterData.cust_f_name)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Mother Name:</b>{' '}
                        {showValue(leadMasterData.cust_m_name)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Spouse Name:</b>{' '}
                        {showValue(leadMasterData.cust_sp_name)}
                      </div>

                      <div className='col-md-4 mb-2'>
                        <b>Father Mobile:</b>{' '}
                        {showValue(leadMasterData.cust_f_mob)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Mother Mobile:</b>{' '}
                        {showValue(leadMasterData.cust_m_mob)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Spouse Mobile:</b>{' '}
                        {showValue(leadMasterData.cust_sp_mob)}
                      </div>

                      <div className='col-md-4 mb-2'>
                        <b>Father Profession:</b>{' '}
                        {showValue(leadMasterData.cust_f_prof)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Mother Profession:</b>{' '}
                        {showValue(leadMasterData.cust_m_prof)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Spouse Profession:</b>{' '}
                        {showValue(leadMasterData.cust_sp_prof)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* LEAD DETAILS */}
                <div className='card mb-4 shadow-sm'>
                  <div className='card-header fw-bold'>Lead Information</div>
                  <div className='card-body'>
                    <div className='row'>
                      <div className='col-md-4 mb-2'>
                        <b>Lead Date:</b> {showValue(leadMasterData.lead_date)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Lead Status:</b>{' '}
                        {showValue(leadMasterData.lead_status)}
                      </div>
                      <div className='col-md-4 mb-2'>
                        <b>Rating:</b> {showValue(leadMasterData.lead_rating)}
                      </div>
                      <div className='col-md-6 mb-2'>
                        <b>Source:</b> {showValue(leadMasterData.lead_source)}
                      </div>
                      <div className='col-12 mb-2'>
                        <b>Remark:</b> {showValue(leadMasterData.lead_remark)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* CONFIRM NOTE */}
                <div className='alert alert-warning small'>
                  Please confirm all details carefully. Once submitted, changes
                  may not be allowed.
                </div>
              </>
            )}
            <div className='d-flex justify-content-between mt-4'>
              <button
                className='btn btn-outline-secondary'
                onClick={prevStep}
                disabled={activeStep === 0}
              >
                <i className='bi bi-arrow-left'></i> Previous
              </button>

              {activeStep < steps.length - 1 ? (
                <button className='btn btn-primary' onClick={nextStep}>
                  Next <i className='bi bi-arrow-right'></i>
                </button>
              ) : (
                <button className='btn btn-success' onClick={handleSubmit}>
                  <i className='bi bi-check-circle'></i> Save Lead
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Customer Popup */}
      {isCustomerPopupOpen && (
        <div
          className='modal fade show'
          tabIndex='-1'
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          role='dialog'
        >
          <div className='modal-dialog modal-lg' role='document'>
            <div className='modal-content'>
              {/* Header */}
              <div className='modal-header'>
                <h5 className='modal-title'>Lead Details</h5>
                <button
                  type='button'
                  className='btn-close'
                  onClick={() => setIsCustomerPopupOpen(false)}
                  aria-label='Close'
                ></button>
              </div>

              {/* Body */}
              <div className='modal-body'>
                <div className='row'>
                  {/* Customer Name */}
                  <div className='mb-3 col-md-6'>
                    <label className='form-label'>Name</label>
                    <input
                      type='text'
                      className='form-control'
                      name='cust_name'
                      value={cust_creation_masterData.cust_name}
                      onChange={onChangeCustomerHandle}
                    />
                  </div>

                  {/* Mobile */}
                  <div className='mb-3 col-md-6'>
                    <label className='form-label'>Mobile</label>
                    <div className='d-flex'>
                      <select
                        className='custom-select'
                        name='country_code'
                        style={{ maxWidth: '100px', marginRight: '10px' }}
                        value={cust_creation_masterData.country_code}
                        onChange={onChangeCustomerHandle}
                      >
                        <option value='+91'>+91</option>
                      </select>
                      <input
                        type='text'
                        className='form-control'
                        name='cust_mobile'
                        value={cust_creation_masterData.cust_mobile}
                        onChange={onChangeCustomerHandle}
                        placeholder='Enter mobile number'
                      />
                    </div>
                  </div>
                </div>

                {/* Email + Company */}
                <div className='row'>
                  <div className='mb-3 col-md-6'>
                    <label className='form-label'>Email</label>
                    <input
                      type='email'
                      className='form-control'
                      name='cust_email'
                      value={cust_creation_masterData.cust_email}
                      onChange={onChangeCustomerHandle}
                    />
                  </div>
                  <div className='mb-3 col-md-6'>
                    <label className='form-label'>Reference</label>
                    <input
                      type='text'
                      className='form-control'
                      name='company_name'
                      value={cust_creation_masterData.company_name}
                      onChange={onChangeCustomerHandle}
                    />
                  </div>
                </div>

                {/* Address + Pincode */}
                <div className='row'>
                  <div className='mb-3 col-md-6'>
                    <label className='form-label'>Address</label>
                    <input
                      type='text'
                      className='form-control'
                      name='address_line1'
                      value={cust_creation_masterData.address_line1}
                      onChange={onChangeCustomerHandle}
                    />
                  </div>
                  <div className='mb-3 col-md-6'>
                    <label className='form-label'>Pincode</label>
                    <input
                      type='text'
                      className='form-control'
                      name='pin_code'
                      value={cust_creation_masterData.pin_code}
                      onChange={onChangeCustomerHandle}
                    />
                  </div>
                </div>

                {/* Country / State / City (equal width) */}
                {/* <div className='row'>
                  <div className='mb-3 col-md-4'>
                    <label className='form-label'>Country</label>
                    <select
                      className='custom-select'
                      name='country_Id'
                      value={cust_creation_masterData.country_Id}
                      onChange={onChangeCustomerHandle}
                    >
                      <option value=''>Select Country</option>
                      {Array.isArray(country) &&
                        country.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.country_name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className='mb-3 col-md-4'>
                    <label className='form-label'>State</label>
                    <select
                      className='custom-select'
                      name='state_Id'
                      value={cust_creation_masterData.state_Id}
                      onChange={onChangeCustomerHandle}
                      disabled={!cust_creation_masterData.country_Id}
                    >
                      <option value=''>Select State</option>
                      {Array.isArray(states) &&
                        states.map((s) => (
                          <option key={s.state_Id} value={s.state_Id}>
                            {s.state_Name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className='mb-3 col-md-4'>
                    <label className='form-label'>City</label>
                    <select
                      className='custom-select'
                      name='city_Id'
                      value={cust_creation_masterData.city_Id}
                      onChange={onChangeCustomerHandle}
                      disabled={!cust_creation_masterData.state_Id}
                    >
                      <option value=''>Select City</option>
                      {Array.isArray(cities) &&
                        cities.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.city_name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div> */}
              </div>

              {/* Footer */}
              <div className='modal-footer'>
                <button
                  type='button'
                  className='btn btn-primary'
                  onClick={customerhandleSubmit}
                >
                  Save
                </button>
                <button
                  type='button'
                  className='btn btn-secondary'
                  onClick={() => setIsCustomerPopupOpen(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ✅ Multipurpose Popup */}
      {modal && (
        <div
          className='modal fade show'
          tabIndex='-1'
          style={{
            display: 'block',
            backgroundColor: 'rgba(0,0,0,0.5)',
          }}
          role='dialog'
        >
          <div className='modal-dialog' role='document'>
            <div className='modal-content'>
              <div
                className='modal-header'
                style={{
                  backgroundColor: 'rgba(55, 0, 255, 1)',
                  color: '#FFFFFF',
                }}
              >
                <h5 className='modal-title'>{dynamicmultipurpose}</h5>
                <button
                  type='button'
                  className='btn-close'
                  onClick={toggle}
                  aria-label='Close'
                ></button>
              </div>
              <div className='modal-body'>
                <div className='form-group'>
                  <label htmlFor='multi_purpose_type'>{dynamiclable}</label>
                  <input
                    id='multi_purpose_type'
                    name='multi_purpose_type'
                    className='form-control'
                    value={MPTMasterData.multi_purpose_type}
                    onChange={onChangeHandle1}
                  />
                </div>

                <div className='form-group'>
                  <label htmlFor='multi_purpose_remark'>Remark</label>
                  <input
                    id='multi_purpose_remark'
                    name='multi_purpose_remark'
                    className='form-control'
                    value={MPTMasterData.multi_purpose_remark}
                    onChange={onChangeHandle1}
                  />
                </div>
              </div>
              <div className='modal-footer'>
                <button
                  className='btn btn-primary mt-2'
                  onClick={MPTMaster_Add_Edit_Screen}
                >
                  Submit
                </button>
                <button className='btn btn-secondary mt-2' onClick={toggle}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default AddLead;
